import ChevronDownIcon from '@assets/icons/chevron-down.svg';
import React from 'react';
import { Button } from '@/components/button';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { formatSummaryDate } from '@/utils/date';
import { FulfillmentName } from '@/types';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { translateFulfillmentType } from '@domain/fulfillment-settings/utils/translate-fulfillment-type';
import { useSupplierOrderAvailability } from '@/hooks/use-supplier-order-availability';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  date: string;
  fulfillmentType: FulfillmentName | null;
  onPress: () => void;
  testID?: string;
  trackingData: TrackingData;
}

export const EditFulfillmentDateButton: React.FC<Props> = ({
  containerStyle,
  date,
  fulfillmentType,
  onPress,
  testID,
  trackingData,
}) => {
  const theme = useTheme();
  const { fulfillmentDisplayName } = useSupplierOrderAvailability();

  return (
    <Button
      containerStyle={containerStyle}
      contentStyle={styles.content}
      onPress={onPress}
      rightElement={
        <ChevronDownIcon fill={theme.colors.primary} height={7} width={14} />
      }
      size="small"
      style={styles.button}
      testID={testID}
      textStyle={[TYPOGRAPHY.small, FONTS.primarySemiBold]}
      trackingData={trackingData}
      type="secondary"
    >
      {translateFulfillmentType(
        fulfillmentType || FulfillmentName.Delivery,
        'fulfillment_for',
        fulfillmentDisplayName,
        { date: formatSummaryDate(date) },
      )}
    </Button>
  );
};

const styles = StyleSheet.create({
  button: {
    borderWidth: 1,
    paddingHorizontal: 16,
  },
  content: {
    justifyContent: 'space-between',
  },
});
